import React from 'react';
import { Modal, Button } from 'antd';

export default function OrderDeleteModal({ open, onCancel, onConfirm, order, loading }) {
  return (
    <Modal
      title="Delete order"
      open={!!open}
      onCancel={onCancel}
      footer={[
        <Button
          key="delete"
          danger
          onClick={onConfirm}
          loading={loading}
          className="app-btn-delete"
        >
          Delete
        </Button>,
        <Button key="cancel" onClick={onCancel} className="app-btn-cancel">
          Cancel
        </Button>,
      ]}
      destroyOnClose
    >
      {order && (
        <>
          Are you sure you want to delete order <strong>{order.orderNumber}</strong> (
          {order.customerName})?
        </>
      )}
    </Modal>
  );
}
